import { ContentType } from '../models/ContentType';
import { SearchResultItem } from '../models/SearchResultTypes';
import { PerformSearchSucceededWithMetadataAction, SearchActionTypes } from './ActionTypes';

export function performSearchSucceededWithMetadata(
  contentType: ContentType,
  data: SearchResultItem[]
): PerformSearchSucceededWithMetadataAction {
  return {
    type: SearchActionTypes.SEARCH_SUCCESS_WITH_METADATA,
    contentType,
    data,
  };
}
